/* @flow */
import * as React from 'react';
import { css } from 'linaria';

import SiteServicesMenu from './SiteServicesMenu';

class ExpandableSiteServicesMenu extends React.Component<
  { onShow: Function, onHide: Function },
  { open: boolean }
> {
  state = { open: false };

  show() {
    let { onShow } = this.props;
    this.setState({ open: true }, onShow);
  }

  hide() {
    let { onHide } = this.props;
    this.setState({ open: false }, onHide);
  }

  toggle() {
    let { open } = this.state;
    if (open) {
      this.hide();
    } else {
      this.show();
    }
  }

  render() {
    let { open } = this.state;

    return (
      <div className={Styles.Container} style={{ height: open ? 350 : 0 }}>
        <SiteServicesMenu />
      </div>
    );
  }
}

const Styles = {
  Container: css`
    transition: all 300ms ease;
    overflow: hidden;
  `,
};

export default ExpandableSiteServicesMenu;



// WEBPACK FOOTER //
// ./src/ui/components/chrome/ExpandableSiteServicesMenu.js